import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faExclamation } from "@fortawesome/free-solid-svg-icons";
import FalconCardHeader from "../common/FalconCardHeader";
import { SelectProperty as SelectPropertyAction } from "../../actions/propertyActions";
import { updateMyProperties } from "../../actions/authActions";
import { checkUserToken } from "../../helpers/api/auth";

/**
 * HO-HU-37: pantalla que ve un propietario con mas de una propiedad
 * vinculada al entrar al dashboard, para elegir con cual quiere trabajar
 * -- mismo rol que CondominiumList2 cumple para un manager con varios
 * condominios.
 *
 * HO-ISSUE-119: la lista se pinta con la que trae el login (user.properties)
 * y ademas se refresca al abrir la pantalla. Sin eso quedaba congelada desde
 * el login: despues de renombrar un inmueble seguian saliendo los nombres
 * viejos, y una unidad recien vinculada o desvinculada por el administrador
 * no aparecia hasta cerrar sesion.
 */
const SelectProperty = () => {
  const dispatch = useDispatch();
  const { properties, token } = useSelector((state) => state.auth.user);
  const { selectedProperty } = useSelector((state) => state.property);

  useEffect(() => {
    let isMounted = true;

    checkUserToken(token)
      .then((profile) => {
        // Si falla la llamada se deja la lista que ya estaba: es mejor
        // mostrar nombres viejos que una pantalla sin propiedades.
        if (isMounted && profile?.properties) {
          dispatch(updateMyProperties(profile));
        }
      })
      .catch(() => {});

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, []);

  const handleSelect = (property) => {
    if (selectedProperty === property.id) return;
    dispatch(SelectPropertyAction(property));
  };

  return (
    <>
      <Card className="mb-3">
        <CardBody>
          <FontAwesomeIcon icon={faExclamation} className="mr-2" />
          Tienes varias propiedades vinculadas a tu cuenta. Haz click en una
          para ver su información.
        </CardBody>
      </Card>
      <Card>
        <FalconCardHeader title="Mis propiedades" />
        <CardBody className="p-0">
          <ListGroup style={{ gap: "10px" }} className="p-3">
            {properties.map((property) => (
              <ListGroupItem
                key={property.id}
                tag="button"
                action
                onClick={() => handleSelect(property)}
                active={selectedProperty === property.id}
                className="d-flex align-items-center"
              >
                <FontAwesomeIcon
                  icon={faBuilding}
                  className="mr-3"
                  size="lg"
                />
                <Row className="flex-grow-1 align-items-center">
                  <Col xs={12} sm={6}>
                    <p className="mb-0 font-weight-semi-bold">
                      {property.property || "(sin identificar)"}
                    </p>
                  </Col>
                  <Col xs={12} sm={6}>
                    <p className="mb-0 fs--1">
                      {property.condominiumName || "Condominio"}
                    </p>
                  </Col>
                </Row>
              </ListGroupItem>
            ))}
          </ListGroup>
        </CardBody>
      </Card>
    </>
  );
};

export default SelectProperty;
